import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { CountUpNumber } from '../shared/GlassCard';
import { getGlobalStats, invalidateGlobalStatsCache } from '../../api/analyticsApi';

function LiveStatsTicker() {
  const location = useLocation();
  const [stats, setStats] = useState({
    totalPlayers: 0,
    totalPrizesPaid: 0,
    totalTicketsSold: 0,
    currentJackpotPool: 0,
  });

  useEffect(() => {
    const loadStats = async (forceRefresh = false) => {
      if (forceRefresh) invalidateGlobalStatsCache();
      const data = await getGlobalStats();
      setStats(data);
    };
    loadStats(true);
    const interval = setInterval(() => loadStats(false), 60000);
    const onVis = () => {
      if (document.visibilityState === 'visible') loadStats(true);
    };
    document.addEventListener('visibilitychange', onVis);
    return () => {
      clearInterval(interval);
      document.removeEventListener('visibilitychange', onVis);
    };
  }, [location.pathname, location.key]);

  const statItems = [
    { label: 'Total Players', value: stats.totalPlayers, prefix: '', suffix: '' },
    { label: 'Prizes Paid', value: stats.totalPrizesPaid, prefix: '$', suffix: '' },
    { label: 'Tickets Sold', value: stats.totalTicketsSold, prefix: '', suffix: '' },
    // { label: 'Current Jackpot', value: stats.currentJackpotPool, prefix: '$', suffix: '' },
  ];

  return (
    <section className="relative py-16 bg-dark-secondary">
      <div className="absolute top-0 left-0 right-0 h-px glow-separator" />

      <div className="container-premium relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {statItems.map((item, index) => (
            <div
              key={index}
              className="text-center p-6 rounded-2xl bg-dark-surface/50 border border-hash-gold/10"
            >
              <div className="text-2xl sm:text-3xl lg:text-4xl font-bold text-hash-gold text-shadow-gold mb-2">
                <CountUpNumber
                  end={item.value}
                  duration={2500}
                  prefix={item.prefix}
                  suffix={item.suffix}
                />
              </div>
              <div className="text-gray-500 text-sm">{item.label}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-px glow-separator" />
    </section>
  );
}

export default LiveStatsTicker;
